import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import Plant from "../Plant";
import { BorderedFormGrid } from "../../Forms/BorderedFormGrid";
import { TextFieldPlaceholder } from "../../Forms/TextFieldPlaceholder";
import { useGoogleMapsModal } from "../../GoogleMaps/useGoogleMapsModal";
import { OpenGoogleMapsIconButton } from "../../GoogleMaps/OpenGoogleMapsIconButton";
import { TextFieldInput } from "../../Forms/TextFieldInput";
import { MdmFormProps } from "../../Forms/MdmFormProps";
import { PlantFormProps } from "./PlantFormProps";

export const PlantCoordinatesForm = ({ disabledFields }: PlantFormProps & MdmFormProps) => {
  const { control } = useFormContext<Plant>();

  const { googleMapsModal, openGoogleMapsModal } = useGoogleMapsModal<Plant>(
    "Latitude",
    "Longitude"
  );

  return (
    <BorderedFormGrid>
      {googleMapsModal}
      <Grid item xs={12}>
        <TextFieldInput
          name="Latitude"
          control={control}
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="Longitude"
          control={control}
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="MapAndGuideLatitude"
          control={control}
          label="M&G Latitude"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="MapAndGuideLongitude"
          control={control}
          label="M&G Longitude"
          disabledFields={disabledFields}
        />
      </Grid>

      {/* PLACEHOLDER */}
      <Grid item xs={12}>
        <TextFieldPlaceholder />
      </Grid>
    </BorderedFormGrid>
  );
};
